
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M8 16A8 8 0 118 0a8 8 0 010 16z","fill":"#2BAC76"}}),_c('path',{attrs:{"d":"M6.762 9.019l3.687-3.736a.646.646 0 01.92.909l-4.148 4.202a.646.646 0 01-.92 0L4.63 8.697a.646.646 0 11.92-.908l1.21 1.229z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    